import { defineAsyncComponent } from 'vue';

/**
 * Google Maps Plugin - Component Registration Only
 *
 * Registers the Google Maps Vue components globally as ASYNC components.
 *
 * Using defineAsyncComponent keeps the map component code — and its heavy
 * transitive deps (@googlemaps/markerclusterer, supercluster, kdbush) — out of
 * the global client chunk that loads on every page. The chunk is fetched only
 * when a page actually renders one of these components (SRP/map views).
 *
 * The Google Maps JS API itself is still loaded lazily via useGoogleMaps().
 */
export default defineNuxtPlugin({
	name: 'google-maps-components',
	setup(nuxtApp) {
		nuxtApp.vueApp.component(
			'GmapMap',
			defineAsyncComponent(
				() => import('@/core/service/googleMaps/components/GmapMap/GmapMap.vue')
			)
		);
		nuxtApp.vueApp.component(
			'GmapMarker',
			defineAsyncComponent(
				() =>
					import('@/core/service/googleMaps/components/GmapMarker/GmapMarker.vue')
			)
		);
		nuxtApp.vueApp.component(
			'GmapCluster',
			defineAsyncComponent(
				() =>
					import('@/core/service/googleMaps/components/GmapCluster/GmapCluster.vue')
			)
		);
		nuxtApp.vueApp.component(
			'GmapClusterRadius',
			defineAsyncComponent(
				() =>
					import('@/core/service/googleMaps/components/GmapClusterRadius/GmapClusterRadius.vue')
			)
		);
		nuxtApp.vueApp.component(
			'GmapQuadrilateral',
			defineAsyncComponent(
				() =>
					import('@/core/service/googleMaps/components/GmapQuadrilateral/GmapQuadrilateral.vue')
			)
		);

		// Note: Google Maps API is loaded lazily via useGoogleMaps() composable.
		// Components that need the API should call:
		//   const { init, api } = useGoogleMaps();
		//   await init();
	}
});
